import React, { forwardRef } from 'react';

// Custom tooltip for react-joyride matching Figma
// Uses dots for progress and blue link-like Next button.
const KeyboardTooltip = forwardRef(function KeyboardTooltip(props, ref) {
  const {
    continuous,
    index,
    size,
    step,
    primaryProps,
    tooltipProps,
  } = props;

  return (
    <div
      {...tooltipProps}
      ref={ref}
      className="kb-joyride-tooltip"
      data-placement={tooltipProps?.['data-placement']}
    >
      {step?.title ? (
        <h4 className="kb-joyride-title">{step.title}</h4>
      ) : null}
      <div className="kb-joyride-content">{step?.content}</div>
      <div className="kb-joyride-footer">
        <div className="kb-joyride-dots" aria-hidden>
          {Array.from({ length: size }).map((_, i) => (
            <span key={i} className={i === index ? 'active' : ''} />
          ))}
        </div>
        {continuous && (
          <button {...primaryProps} className="kb-joyride-next">
            {index === size - 1 ? 'Done' : 'Next'}
          </button>
        )}
      </div>
      <div className="kb-joyride-arrow" />
    </div>
  );
});

export default KeyboardTooltip;
